import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of, Subject } from "rxjs";

import { tap,switchMap,take } from "rxjs/operators";
import { BaseResponse, } from "src/app/models/base-response.model";
import {  SiteCultureGetAllResponse,NewSiteCulture } from "../new-sites-management/common/models/data-models";

@Injectable({
  providedIn: "root",
})
export class SiteService {
  isSiteChanged: boolean;
  SiteChanged: Subject<boolean> = new Subject<boolean>();

  siteCuturesSubject = new BehaviorSubject<any[]>(null);
  siteCutures$: Observable<any[]> = this.siteCuturesSubject.asObservable();
  private usedSiteCultureSubject = new BehaviorSubject<NewSiteCulture[]>(null);
  usedSiteCulture$: Observable<NewSiteCulture[]> = this.usedSiteCultureSubject.asObservable();
  private siteCultureSubject = new BehaviorSubject<BaseResponse<SiteCultureGetAllResponse[]>>(null);
  siteCulture$: Observable<BaseResponse<SiteCultureGetAllResponse[]>> = this.siteCultureSubject.asObservable();
  private allUserSitesSubject = new BehaviorSubject<any[]>(null);
  allUserSites$: Observable<any[]> = this.allUserSitesSubject.asObservable();


  constructor(
    private http: HttpClient
  ) {
    this.getUsedSiteCultures(2).subscribe();
    // this.SiteChanged.subscribe((value) => {
    //   this.isSiteChanged = value;
    //   this.getSiteCultures().subscribe();
    // });

  }
  public getAllCultures() {
    return this.siteCulture$.pipe(
      take(1),
      switchMap(res => {
        if (res) { return of(res); }
        else { return this.http.get<BaseResponse<any[]>>("/currency/get-used-cultures") }
      }),
      tap(res => res && this.siteCultureSubject.next(res))
    )
  }

  getSiteCultures() {
    return this.http.get('/SiteCulture/GetCulturesBySiteId')
      .pipe(
        tap((res: any[]) => res && this.siteCuturesSubject.next(res))
      )
  }

  getUsedSiteCultures(status) {
    return this.http.get(`/Sites/GetUsedSiteCulturesByStatus/${status}`)
      .pipe(
        tap((res: any[]) => res && this.siteCuturesSubject.next(res))
      )
  }
  public getUsedCulturs(siteId?: number) {
    return this.http.get<NewSiteCulture[]>(
      `/Sites/GetUsedSiteCultures/${siteId || 0}`
    ).pipe(
      tap((res: NewSiteCulture[]) => res && this.usedSiteCultureSubject.next(res))
    )
  }
  public getSiteDetails(id: number) {
    return this.http.get<any>(`/Sites/GetSiteDetails/${id}`);
  }

  //
  public getSites() {
    const current = this.allUserSitesSubject.getValue();
    if (current) {
      return of(current)
    }
    return this.http.get("/Sites/GetAllSites").pipe(
      tap((res: any[]) => res && this.allUserSitesSubject.next(res)),

    );
  }
  reset() {
    this.allUserSitesSubject.next(null);
    this.getSites().subscribe();
  }
  isSiteExist() {
    this.SiteChanged.next(this.isSiteChanged);
    this.isSiteChanged = false;
  }
}
